import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { ProvinceFilter } from '../model/geography/province-filter';
import { LocalityFilter } from '../model/geography/locality-filter';
import { CountryFilter } from '../model/geography/country-filter';
@Injectable()
export class GeographyService {
    constructor(private http: HttpClient, private dataService: DataService) { }
    private readonly getProvinceFiltersEndPoint: string = '/geography/getProvinceFilters/';
    private readonly getLocalityFiltersEndPoint: string = '/geography/getLocalityFilters/';
    private readonly getCountryFiltersEndPoint: string = '/geography/getCountryFilters/';
    async getCountryFilters(): Promise<CountryFilter[]> {
        const param = {};
        return await this.dataService.get<CountryFilter[]>(this.getCountryFiltersEndPoint, param).toPromise();
    }
    async getProvinceFilters(countryId: number, name: string): Promise<ProvinceFilter[]> {
        const param = { countryId: countryId, name: name };
        return await this.dataService.get<ProvinceFilter[]>(this.getProvinceFiltersEndPoint, param).toPromise();
    }
    async getLocalityFilters(provinceId: number, name: string): Promise<LocalityFilter[]> {
        const param = { provinceId: provinceId, name: name };
        return await this.dataService.get<LocalityFilter[]>(this.getLocalityFiltersEndPoint, param).toPromise();
    }
}
